import { render, staticRenderFns } from "./ImsTemplateDialog.vue?vue&type=template&id=6248077a&"
import script from "./ImsTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./ImsTemplateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports